module.exports = __webpack_public_path__ + "img/st2.ea57ac40.png";